import React from 'react';
import './gameUi.css';
import {getPlayerColorStyle} from '../../utils/gameUi/getPlayerColorStyle';
import {joinClassNames} from './joinClassNames';

// Материал плиты — источник цвета дизайн-системы матча
// (см. src/styles/gameUi/tokens.css)
export const GAME_PANEL_MATERIALS = Object.freeze({
  SHEET: 'sheet', // нейтральный базальт: панели, меню, модалки
  BAR: 'bar', // нейтральный базальт полос: шапка, футер, ярлыки
  PHASE: 'phase', // эмаль цвета фазы
  MINE: 'mine', // эмаль цвета игрока — «мое»
  BONE: 'bone', // светлый жетон — только для чисел над полем
});

// Какие углы срезаны: all — все четыре, bottom — нижние (шапка), top —
// верхние (футер), right — правые (ярлык у левого края), s — мелкий срез
// (плитки и кнопки), hex — шестиугольник
export const GAME_PANEL_SHAPES = Object.freeze({
  ALL: 'all',
  S: 's',
  BOTTOM: 'bottom',
  TOP: 'top',
  RIGHT: 'right',
  HEX: 'hex',
});

/**
 * Плита с фаской — основа всех панелей матча
 * @param {string} [material] - GAME_PANEL_MATERIALS
 * @param {string} [shape] - GAME_PANEL_SHAPES
 * @param {boolean} [shadow] - тень под плитой; только для крупных блоков
 * @param {string} [playerColor] - цвет игрока для материала MINE
 * @param {string} [as] - тег
 */
export function GamePanel({
  material = GAME_PANEL_MATERIALS.SHEET,
  shape = GAME_PANEL_SHAPES.ALL,
  shadow = false,
  playerColor,
  as: Tag = 'div',
  className,
  style,
  children,
  ...rest
}) {
  const panel = (
    <Tag
      className={joinClassNames(
        'gui-plate',
        material !== GAME_PANEL_MATERIALS.SHEET && `gui-plate_${material}`,
        shape !== GAME_PANEL_SHAPES.ALL && `gui-shape_${shape}`,
        !shadow && className,
      )}
      style={{...getPlayerColorStyle(playerColor), ...(shadow ? null : style)}}
      {...(shadow ? null : rest)}
    >
      {children}
    </Tag>
  );

  if (!shadow) {
    return panel;
  }

  // Тень от clip-path обрезается самим элементом — она вешается на обертку,
  // и позиционирование (className, style) тоже переходит к обертке
  return (
    <div className={joinClassNames('gui-shadow', className)} style={style} {...rest}>
      {panel}
    </div>
  );
}

export default GamePanel;
